// @ts-nocheck
/* eslint-disable */
export const appBackArrow32Icon = {
    data: `<svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="17" cy="17" r="16" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 12L14 17.5L20 23" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'back-arrow-32' as const
};